
export class VeiculoEquipamentoTableDTO {
    
    nrPlaca: string = void(0);
    dtInstalacao: Date = void(0);
    dtDesinstalacao: Date = void(0);

    constructor() { }
}

export class VeiculoEquipamentoTableListDTO {
    items: Array<VeiculoEquipamentoTableDTO>;
    total: number;
    constructor() {}
}
